// extracted by mini-css-extract-plugin
module.exports = {"base":"tagStorySearch-m__base__pqXkE","tag-search-btn":"tagStorySearch-m__tag-search-btn__cJFQQ","search-icon":"tagStorySearch-m__search-icon__34ddg"};